import React, { useEffect, useRef, useState } from 'react';
import { Mic, MicOff } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

// Voice commands for cooking flow - free via Web Speech API
export default function VoiceControl({ onCommand }) {
  const { t, lang } = useLang();
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);

  useEffect(() => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return;
    const rec = new SR();
    rec.continuous = true;
    rec.interimResults = false;
    rec.lang = lang === 'ar' ? 'ar-SA' : lang === 'fr' ? 'fr-FR' : lang === 'es' ? 'es-ES'
              : lang === 'tr' ? 'tr-TR' : lang === 'ur' ? 'ur-PK' : 'en-US';

    rec.onresult = (e) => {
      const transcript = Array.from(e.results).slice(-1)[0][0].transcript.toLowerCase().trim();
      // Multi-language command matching
      const map = [
        { keys: ['next', 'التالي', 'suivant', 'siguiente', 'sonraki', 'اگلا'], cmd: 'next' },
        { keys: ['previous', 'back', 'السابق', 'précédent', 'anterior', 'önceki', 'پچھلا'], cmd: 'prev' },
        { keys: ['start', 'timer', 'ابدأ', 'بدا', 'commencer', 'iniciar', 'başlat', 'شروع'], cmd: 'start' },
        { keys: ['stop', 'pause', 'اوقف', 'أوقف', 'arrêter', 'parar', 'durdur', 'روکیں'], cmd: 'stop' },
      ];
      for (const m of map) {
        if (m.keys.some(k => transcript.includes(k))) {
          onCommand?.(m.cmd);
          break;
        }
      }
    };
    rec.onend = () => setListening(false);
    recRef.current = rec;
  }, [lang, onCommand]);

  const toggle = () => {
    if (!recRef.current) return;
    if (listening) {
      recRef.current.stop();
      setListening(false);
    } else {
      try { recRef.current.start(); setListening(true); } catch { /* already started */ }
    }
  };

  if (!(window.SpeechRecognition || window.webkitSpeechRecognition)) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="voice-toggle"
      className={`relative inline-flex h-14 w-14 items-center justify-center rounded-full shadow-md transition-all ${
        listening ? 'bg-[#C05A42] text-white pulse-ring' : 'bg-white text-[#C05A42] border border-black/5'
      }`}
      aria-label={t('voiceCommand')}
    >
      {listening ? <Mic className="h-6 w-6" /> : <MicOff className="h-6 w-6" />}
    </button>
  );
}
